import { api } from '@/helpers/api'
import { ActivityCodeEnum } from '@/helpers/commonConsts'
import { commonUtils } from '@/helpers/commonUtils'
import { action, computed, makeObservable, observable } from 'mobx'

class UserService {
  @observable userData: ServerData.UserData | null = null
  @observable Activitys: ServerData.ActivityData[] | null = null

  @computed
  get newUserActivity() {
    return this.Activitys?.find((item) => item.activityCode === ActivityCodeEnum.NEW_USER_ACTIVITY)
  }

  @computed get isLogin() {
    return this.userData !== null
  }

  // 是否是vip
  @computed get isVip() {
    return this.userData?.userVersion?.version === 'vip'
  }

  // 兑换码数量
  @computed get exchangeCodeCount() {
    return this.userData?.exchangeCodeInfo?.count ?? 0
  }

  constructor() {
    makeObservable(this)
  }

  public init() {
    this.getUserInfo()
    this.updateUtmInfo()
  }

  public updateUtmInfo() {
    const { slug_code, utm = '', kword = '' } = commonUtils.getUrlArgs()
    if (utm) {
      localStorage.setItem('utm', utm)
      sessionStorage.setItem('utm', utm)
    }

    if (kword) {
      localStorage.setItem('kword', kword)
      sessionStorage.setItem('kword', kword)
    }

    if (slug_code) {
      localStorage.setItem('slug_code', slug_code)
      sessionStorage.setItem('slug_code', slug_code)
    }

    // const cleanUrl = commonUtils.removeQueryFromUrl(window.location.href)
    // if (window.location.href !== cleanUrl) {
    //   window.history.replaceState(null, document.title, cleanUrl)
    // }
  }

  public postUserActionRecord(data: PostData.UserActionInfo) {
    try {
      const isMobile = commonUtils.getIsMobile()
      const referer = commonUtils.getUrlArgs().referer || document.referrer
      const defRemark = {
        referer,
        utm: sessionStorage.getItem('utm'),
        kword: sessionStorage.getItem('kword'),
        slugCode: sessionStorage.getItem('slug_code'),
      }
      let remark = data.remark ? { ...defRemark, ...data.remark } : defRemark
      const _data = {
        ...data,
        clientType: !isMobile ? 'pc' : 'mobile',
        remark,
      }
      api.user.postUserActionRecord(_data).catch((e) => {
        console.log(e)
      })
    } catch (error) {}
  }

  @action
  public async getUserInfo() {
    try {
      const data = await api.user.getUserInfo()
      this.userData = data.data
      this.getActivity()
    } catch (error) {
      //
    }
  }

  public logout() {
    this.userData = null
    api.user.logout()
  }

  public async getActivity() {
    if (!this.isLogin) return
    const res = await api.user.getActivity()
    this.Activitys = res.dataList
    return res.dataList
  }
}

export const userService = new UserService()
